import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { CustomErrorHandler } from '../../../services/error-handler.service';
import { ErrorModel } from '../../../models/error-model';
import { TokenizationBootstrapService } from '../../../services/tokenization-bootstrap.service';

@Component({
  selector: 'app-root',
  template: `
    <div class="vh-100">
      <router-outlet></router-outlet>
    </div>
  `,
  styles: [
  ]
})
export class BootstrapComponent {
  private unsubscriber: Subject<void> = new Subject();

  constructor(
    private errorHandler: CustomErrorHandler,
    private router: Router,
    private route: ActivatedRoute,
    private tokenizationBootstrap: TokenizationBootstrapService,
  ) {
    this.tokenizationBootstrap.subscribeToQueryParams(this.route, this.unsubscriber);
  }

  ngOnInit() {
    this.errorHandler.listenToCspViolations();
    this.subscribeToErrors();
  }
  ngOnDestroy() {
    this.unsubscriber.next();
    this.unsubscriber.complete();
  }

  private subscribeToErrors(): void {
    this.errorHandler.errors$
    .pipe(takeUntil(this.unsubscriber))
    .subscribe((errorModel: ErrorModel) => {
      this.router.navigate(["/err"]);
    });
  }

}

